<template>
	<el-tabs value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('labourInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="labourForm" :rules="rules" ref="labourForm" label-width="200px">
            <el-card>
              <el-row>
                <el-col style="margin-bottom: 10px;" :xs="24" :md="24">
                  <el-button type="primary" size="mini" @click.prevent="addRow()">{{$t('add')}}</el-button>
                  <el-button type="primary" size="mini" @click.prevent="deleteRow()">{{$t('delete')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="24">
                  <el-table id="suffixId" :data="labourForm.labourData" style="width:100%" ref="table" tooltip-effect="dark" border @selection-change="selectRow">
                    <el-table-column type="selection" width="45" align="center" key="slt"></el-table-column>
                    <el-table-column :label="$t('sequnce')" fixed type="index" sortable width="85" align="center" :key="Math.random()"></el-table-column>
                    <el-table-column v-if="false" key="sqs"><template slot-scope="scope"><el-input v-model="scope.row.sequnces"></el-input></template></el-table-column>
                    <el-table-column align="center" fixed key="sn" min-width="140">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('subtaskName')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.subtaskName'" :rules='rules.subtaskName' label-width="0px">
                          <el-input v-model="scope.row.subtaskName" @click.native="selectSubtask(scope.$index,)"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="wd" min-width="140">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workDate')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workDate'" :rules='rules.workDate' label-width="0px">
                          <el-date-picker v-model="scope.row.workDate" :picker-options="pickerOptions" 
                            :editable="true" clearable type="date" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="wct" min-width="130">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workContent')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workContent'" :rules='rules.workContent' label-width="0px">
                          <el-select v-model="scope.row.workContent" @focus="selectSubtaskName(scope.row)" clearable >
                            <el-option v-for="item in DeliveryTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('workDescribe')" align="center" key="des" min-width="130">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workDescribe'" :rules='rules.workDescribe' label-width="0px">
                          <el-input v-model="scope.row.workDescribe" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="wh" min-width="120">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workHours')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workHours'" :rules='rules.workHours' label-width="0px">
                          <el-input v-model="scope.row.workHours" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="ths" min-width="140">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('travelHours')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.travelHours'" :rules='rules.travelHours' label-width="0px">
                          <el-input v-model="scope.row.travelHours" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                     <el-table-column align="center" key="pl" min-width="140">
                      <template slot="header">
                        <span>{{$t('ProductLine')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'labourData.' + scope.$index + '.productLine'"
                          :rules="[
                            {
                              required: (
                                scope.row.subtaskRemark=='MSS' ||
                                scope.row.subtaskRemark=='WDC'||
                                scope.row.subtaskRemark=='BC' ||
                                scope.row.subtaskRemark=='PID'||
                                scope.row.subtaskRemark=='PI' ||
                                scope.row.subtaskDeliveryType=='HB_HQB_SSC' ||
                                scope.row.subtaskDeliveryType=='NECCase(Warranty)' ||
                                scope.row.subtaskDeliveryType=='HB_HQB_WTY' ||
                                scope.row.subtaskDeliveryType=='POC' 
                              ) ? true : false,
                              message:'Please select data',
                              trigger: 'change'
                            },
                            { validator: '', trigger: 'change' }
                          ]"
                          label-width="0px"
                        >
                          <el-select
                            v-model="scope.row.productLine"
                            clearable
                            :disabled="(
                              scope.row.subtaskRemark=='MSS' ||
                              scope.row.subtaskRemark=='WDC'||
                              scope.row.subtaskRemark=='BC' ||
                              scope.row.subtaskRemark=='PID'||
                              scope.row.subtaskRemark=='PI' ||
                              scope.row.subtaskDeliveryType=='HB_HQB_SSC' ||
                              scope.row.subtaskDeliveryType=='NECCase(Warranty)' ||
                              scope.row.subtaskDeliveryType=='HB_HQB_WTY' ||
                              scope.row.subtaskDeliveryType=='POC' 
                            ) ? false : true"
                          >
                            <el-option v-for="item in scope.row.productLineList" :key="item.pl2" :label="item.pl2" :value="item.pl2"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('ocmsCaseNumber2')" align="center" min-width="200" key="ocn">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.ocmsCaseNumber'" :rules="[{ required: (scope.row.subtaskDeliveryType=='HB_HQB_SSC' || scope.row.subtaskDeliveryType=='NECCase(Warranty)' || scope.row.subtaskDeliveryType=='NECCase') ?true:false,message:'Please input value', trigger: 'change' },{ validator: '', trigger: 'change' }]"  label-width="0px">
                          <el-input v-model="scope.row.ocmsCaseNumber" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('pasvno')" align="center" min-width="250" key="pso">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px">
                          <el-input v-model="scope.row.serviceContractNo" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('accountName')" align="center" min-width="200" key="acne">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.accountName'"  :rules="[{ required: (scope.row.subtaskDeliveryType=='HB_HQB_SSC' || scope.row.subtaskDeliveryType=='CV') ?true:false,message:'Please input value', trigger: 'change' },{ validator: '', trigger: 'change' }]" label-width="0px" >
                          <el-input v-model="scope.row.accountName" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('representativeSupport')" align="center" key="rmk" min-width="160">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.representativeSupport'"  :rules="[{ required: (scope.row.subtaskDeliveryType=='HB_HQB_MKT' || scope.row.subtaskDeliveryType=='HB_HQB_SVS') ?true:false,message:'Please input value', trigger: 'change' },{ validator: '', trigger: 'change' }]" label-width="0px">
                          <el-select v-model="scope.row.representativeSupport" clearable :disabled="!(scope.row.subtaskDeliveryType=='HB_HQB_MKT'|| scope.row.subtaskDeliveryType=='HB_HQB_SVS')" :placeholder="$t('select')">
                            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('remark')" align="center" key="rmk" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px">
                          <el-input v-model="scope.row.remark" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
							<el-row>
								<el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('labourForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
							</el-row>
					  </el-card>
          </el-form>
          <Modal v-model="modelSubtask" width="70%" :closable='true' :mask-closable='false' :title="$t('selectSubtask')">
            <div slot="footer"></div>
            <!-- 查询选项 -->
            <Form class="modelForm" :label-width="115">
              <FormItem class="modelItem" :label="$t('taskName1')">
                <Input clearable v-model="tkName" :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('subtaskName1')">
                <Input clearable v-model="subName" :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem modelItemSelect" :label="$t('country1')">
                <el-select filterable v-model="country" clearable :placeholder="$t('select')">
                  <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
                </el-select>
              </FormItem>
              <FormItem class="modelItem" :label="$t('Project Name')">
                <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem modelItemSelect" :label="$t('projectType1')">
                <el-select filterable v-model="subtaskRemark" clearable :placeholder="$t('select')">
                  <el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem class="modelItem" :label="$t('Service Contract NO')">
                <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('Account Name')">
                <Input clearable v-model="customerName" :placeholder="$t('enter')"/>
              </FormItem>
              <div class="buttonDiv">
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchSubtaskList">{{$t('search')}}</el-button>
              </div>
            </Form>
            <el-table :data="SubTList" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column prop="subtaskName" :label="$t('subtaskName')" align="left" min-width="280" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="taskName" :label="$t('taskName')" align="left" min-width="330" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="serviceStartDate" :label="$t('serviceStartDate')" align="center" min-width="160"></el-table-column>
              <el-table-column prop="serviceEndDate" :label="$t('serviceEndDate')" align="center" min-width="160"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[5,10,50,100]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
              </el-pagination>
            </div>
          </Modal>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>
<style scoped>
.modelForm .modelItem{
  height:50px !important;
}
</style>

<script>
    import * as validate from '@/utils/validate'
    export default {
        name: 'labourEnter',
        activated () {
          let lEnter = this.$route.params.lEngineerTolEnter;
          if(lEnter == 'N'){
            this.labourForm.labourData = [];
            this.getSubtaskList();
            this.getUserHourList();
          }
          let taskId = this.$route.params.taskId;
          if (taskId) {
            this.addRow(this.$route.params)
          }
        },
        created () {
          this.getSubtaskList();
          this.getUserHourList();
          this.getCountry();
          this.getProjectTypeList();
        },
        data () {
          var checkWorkDate = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let skName = this.labourForm.labourData[index].subtaskName;
            if(skName == null || skName == ""){
              this.labourForm.labourData[index].workDate = null;
              return callback(new Error("Please select subtask first"));
            }else{
              let startDate = this.timeFormat(this.labourForm.labourData[index].serviceStartDate);
              let endDate = this.timeFormat(this.labourForm.labourData[index].serviceEndDate);
              let currDate = this.timeFormat(new Date());
              let sdate = this.sdate;
              let inputV = this.timeFormat(value);
              if(startDate > currDate || endDate < sdate){
                return callback(new Error("Not in subtask time range"));
              }else if(startDate < sdate){
                if(endDate <= currDate && inputV > endDate){
                  return callback(new Error("Subtask end date cannot be exceeded"));
                }
              }else{
                if(inputV < startDate){
                  return callback(new Error("Subtask start date cannot be exceeded"));
                }else if(inputV > endDate){
                  return callback(new Error("Subtask end date cannot be exceeded"));
                }
              }
            }
            callback();
          };
          var checkHours = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }
            let taskNm = this.labourForm.labourData[index].taskId;
            if(taskNm != null && taskNm.indexOf("PersonalLeave") != -1){
              if(value < 0.01 || value > 8){
                return callback(new Error('Please enter 0.01--8.00'));
              }
            }else{
              if(value < 0.01 || value > 24){
                return callback(new Error('Please enter 0.01--24.00'));
              }
            }
            let whour = this.labourForm.labourData[index].workHours;
            let thour = this.labourForm.labourData[index].travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            let wDate = this.labourForm.labourData[index].workDate;
            wDate = this.timeFormat(wDate);
            if(wDate != null && wDate != ""){
              let uhour = 0;
              this.userHours.forEach(item => {
                let iDate = this.timeFormat(item.workDate);
                if (iDate == wDate) {
                  uhour = item.workHours;
                }
              });
              let sum = parseFloat(whour) + parseFloat(uhour);
              if(sum > 24){
                return callback(new Error('Working hours per day shall not exceed 24 hours'));
              }else{
                let hdata = this.labourForm.labourData;
                if(hdata.length > 1){
                  let vhour = 0;
                  hdata.forEach(item => {
                    let iDate = this.timeFormat(item.workDate);
                    if (iDate == wDate) {
                      vhour = parseFloat(vhour) + parseFloat(item.workHours);
                    }
                  });
                  let sum = parseFloat(vhour) + parseFloat(uhour);
                  if(sum > 24){
                    return callback(new Error('Working hours per day shall not exceed 24 hours'));
                  }
                }
              }
            }
            callback();
          };
          var checkTravelHours = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }else if(value < 0 || value > 24){
              return callback(new Error('Please enter 0--24.00'));
            }
            let whour = this.labourForm.labourData[index].workHours;
            let thour = this.labourForm.labourData[index].travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            callback();
          };
          var changeOcmsCaseNo = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let tkNumber = this.labourForm.labourData[index].taskId;
            if(tkNumber != null && tkNumber != ""){
              if(tkNumber.indexOf("Maintenance") != -1 || tkNumber.indexOf("Case") != -1 || tkNumber.indexOf("NECCase") != -1){
                if(value == null || value== ""){
                  return callback(new Error("Please input value"));
                }
              }
            }
            callback();
          };
          var checkDescribe = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let content = this.labourForm.labourData[index].workContent;
            if(content == 'Others'){
              if(value == null || value == ''){
                return callback(new Error('Please enter describe'));
              }
            }
            callback();
          };
          return {
            pickerOptions: {disabledDate: time => {return this.selectWorkDate(time)}},
            labourForm: {
              labourData:[],
            },
            subtaskDeliveryType: '',
            subName:null,
            tkName:null,
            country:null,
            projectName:null,
            subtaskRemark:null,
            serviceContractNo:null,
            customerName:null,
            num:0,
            sdate:null,
            labourIndex:null,
            modelSubtask:false,
            multipleSelection:[],
            SubTList:[],
            subtasks:[],
            userHours:[],
            DeliveryTypeList:[],
            bomContent:null,
            mstContent:null,
            currentPage: 1,
            totalCount: 0,
            pageSize: 5,
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            rules: {
              subtaskName: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkWorkDate, trigger: 'change' }
              ],
              workHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkHours, trigger: 'blur' }
              ],
              workContent: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDescribe: [
                { validator: checkDescribe, trigger: 'blur' }
              ],
              travelHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkTravelHours, trigger: 'blur' }
              ],
              productLine:[
                { required: false, message:'Please select data', trigger: 'change' },
                { validator: '', trigger: 'change' }
              ],
              ocmsCaseNumber: [
                { required: false, message:'Please input value', trigger: 'change' },
                { validator: changeOcmsCaseNo, trigger: 'blur' }
              ],
              accountName: [
                { required: true, message:'Please input value', trigger: 'change' },
              ],
              representativeSupport: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
            },
            ProjectTypeList:[],
            CountryList: [],
          }
        },
        methods:{
          getUserHourList(){
            let url =`${this.$store.state.islhurl}labourHour/getHour`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.userHours = res.labours;
              }
            )
          },
          getSubtaskList(){
            let url =`${this.$store.state.islhurl}getUserSubtaskList/${this.pageSize}/${this.currentPage}`;
            let pm = {
              taskName: this.tkName==''?null:this.tkName,
              subtaskName: this.subName==''?null:this.subName,
              country: this.country ==''?null:this.country,
              projectName: this.projectName==''?null:this.projectName,
              subtaskRemark: this.subtaskRemark==''?null:this.subtaskRemark,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              customerName:this.customerName==''?null:this.customerName,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.SubTList = res.data;
                this.subtasks = res.data;
                this.totalCount = res.totalNums
                this.sdate = res.sdate;
              }
            )
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getProjectTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'ProjectType',
            }
            this._post(url,pm).then(
              res =>{
                this.ProjectTypeList = res.data;
              }
            )
          },
          getProductLineList(subtask, index){
            let url = `${this.$store.state.islhurl}productline/getSelectData`
            let pm = {
              subtaskRemark:subtask.subtaskRemark,
              taskId:subtask.taskId,
            }
            this._post(url,pm).then(
              res =>{
                this.$set(this.labourForm.labourData[index], 'productLineList', res.data);
              }
            )
          },
          searchSubtaskList(){
            this.pageSize = 5;
            this.currentPage = 1;
            let url =`${this.$store.state.islhurl}getUserSubtaskList/${this.pageSize}/${this.currentPage}`;
            let pm = {
              taskName: this.tkName==''?null:this.tkName,
              subtaskName: this.subName==''?null:this.subName,
              country: this.country ==''?null:this.country,
              projectName: this.projectName==''?null:this.projectName,
              subtaskRemark: this.subtaskRemark==''?null:this.subtaskRemark,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              customerName:this.customerName==''?null:this.customerName,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.SubTList = res.data;
                this.totalCount = res.totalNums
              }
            )
          },
          selectSubtask(index){
            this.labourIndex = index;
            this.tkName = null;
            this.subName = null;
            this.country = null;
            this.projectName = null;
            this.subtaskRemark = null;
            this.serviceContractNo = null;
            this.customerName=null;
            this.SubTList = this.subtasks;
            this.modelSubtask = true;
          },
          handleSubtask(item){
            let index = this.labourIndex;
            this.labourForm.labourData[index].projectId = item.projectId;
            this.labourForm.labourData[index].taskId = item.taskId;
            this.labourForm.labourData[index].subtaskId = item.subtaskNumber;
            this.labourForm.labourData[index].subtaskName = item.subtaskName;
            this.labourForm.labourData[index].serviceStartDate = item.serviceStartDate;
            this.labourForm.labourData[index].serviceEndDate = item.serviceEndDate;
            this.labourForm.labourData[index].subtaskDeliveryType = item.subtaskDeliveryType;
            this.labourForm.labourData[index].projectType = item.projectType;
            this.labourForm.labourData[index].subtaskRemark = item.subtaskRemark;
            this.$set(this.labourForm.labourData[index], 'productLine', null);
            this.$set(this.labourForm.labourData[index], 'representativeSupport', null);
            this.getProductLineList(item, index)
            if(item.taskId.indexOf("PersonalLeave") != -1){
              this.labourForm.labourData[index].workContent = "Personal Leave";
            }else{
              this.labourForm.labourData[index].workContent = null;
            }
            //Project Type为warranty delivery、Service Contract Delivery，选中自动带出Account Name 
            if(item.subtaskRemark=='WDC' || item.subtaskRemark=='CDC'){   
              this.labourForm.labourData[index].accountName = item.customerName;
            }
            this.modelSubtask = false;
            this.bomContent = item.deliveryEngineerCity;
            this.mstContent = item.deliveryAddress;
          },
          selectSubtaskName(row){
            //通过任务类型查询交付类型
            if(row.subtaskDeliveryType != undefined){
              if(row.subtaskDeliveryType == ''){
                this.DeliveryTypeList = [];
              }else if(row.subtaskDeliveryType == 'Value' || row.subtaskDeliveryType == 'Training Service'){
                // this.DeliveryTypeList = [{sysDesc:row.deliveryEngineerCity,sysValue:row.deliveryEngineerCity}];
                this.DeliveryTypeList = [{sysDesc:this.bomContent,sysValue:this.bomContent}];
              }else if(row.subtaskRemark == 'MST'){
                // this.DeliveryTypeList = [{sysDesc:row.deliveryAddress,sysValue:row.deliveryAddress}];
                this.DeliveryTypeList = [{sysDesc:this.mstContent,sysValue:this.mstContent}];
              }else{
                let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
                let pm = {
                  sysKey: 'SubtaskDeliveryType',
                  remark: row.subtaskDeliveryType,
                }
                this._post(url,pm).then(
                  res => {
                    this.DeliveryTypeList = res.data;
                  }
                )
              }
            }
          },
          selectWorkDate(time){
            return (time > new Date() || time.getTime() < new Date(this.sdate)  - 8.64e7);
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.addInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          addInfo(){
            if(this.labourForm.labourData.length == 0){
              this.$message.warning('Please add the labour hour first！');
              return;
            }
            let labourHours = this.labourForm.labourData.map(item => {
              let { productLineList, ...rest } = item;
              return rest;
            });
            let params = {
              labourHours : labourHours,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}labourHour/enterInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.labourForm.labourData = [];
                  this.$Message.success('Save successful');
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    message:res
                  });
                }
              }
            )
          },
          addRow(obj){
            let addlist = {};
            let length = this.labourForm.labourData.length;
            if(length > 0 && !obj){
              let labourData = this.labourForm.labourData[length-1];
              console.log(labourData)
              addlist = {
                sequnces:labourData.sequnces+1,projectId:labourData.projectId,taskId:labourData.taskId,subtaskId:labourData.subtaskId,
                subtaskName:labourData.subtaskName,workDate:labourData.workDate,workHours:labourData.workHours,workContent:labourData.workContent,
                workDescribe:labourData.workDescribe,travelHours:labourData.travelHours,
                productLine:labourData.productLine,
                hardwareProductLine:labourData.hardwareProductLine,
                serviceProductLine:labourData.serviceProductLine,ocmsCaseNumber:labourData.ocmsCaseNumber,serviceContractNo:labourData.serviceContractNo,
                accountName:labourData.accountName,remark:labourData.remark,
                subtaskRemark:labourData.subtaskRemark,subtaskDeliveryType:labourData.subtaskDeliveryType,
                representativeSupport:labourData.representativeSupport,
                productLineList:labourData.productLineList ? [...labourData.productLineList] : [],
              };
            }else{
              let workTime = new Date();
              let wkTime = this.$route.params.wkTime;
              if(wkTime != undefined && wkTime != null && wkTime != ''){
                workTime = wkTime;
              }
              addlist = {
                sequnces:this.num++,
                projectId:null,
                taskId:null,
                subtaskId:null,
                subtaskName:null,
                workDate:workTime,
                workHours:null,
                workContent:null,
                workDescribe:null,
                travelHours:0,
                productLine:null,
                hardwareProductLine:null,
                serviceProductLine:null,
                ocmsCaseNumber:null,
                serviceContractNo:null,
                accountName:null,
                remark:null,
                representativeSupport:null,
                productLineList:[],
              };
            }
            this.labourForm.labourData.push(addlist);
            if (obj && obj.taskId) {
              this.labourForm.labourData = [addlist];
              this.labourIndex = 0
              this.handleSubtask(obj)
            }
          },
          selectRow(val){
            this.multipleSelection = val;
          },
          deleteRow() {
            if(this.multipleSelection.length == 0){
              this.$message.warning('Please choose the data first！');
              return;
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
              let val = this.multipleSelection;
              val.forEach((val, index) => {
                this.labourForm.labourData.forEach((v, i) => {
                  if (val.sequnces === v.sequnces) {
                    // i 为选中的索引
                    this.labourForm.labourData.splice(i, 1);
                  }
                });
              });
            }
          },
          returnList(){
            let homeDate = [];
            let wkTime = this.$route.params.wkTime;
            if(wkTime != undefined && wkTime != null && wkTime != ''){
              homeDate = [wkTime,wkTime];
            }
            let pm = {
              homeDate: homeDate,
            }
            this.$router.push({name:'labourEngineer',params:pm});
          },
          changePage (val) {
            this.currentPage = val;
            this.getSubtaskList();
          },
          changePageSize (val) {
            this.pageSize = val;
            this.getSubtaskList();
          },
          timeFormat (time) {
            if(time == null || time == ""){
              return null;
            }
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth() + 1;
            const date = dateTime.getDate();
            // const hour = dateTime.getHours()
            // const minute = dateTime.getMinutes()
            // const second = dateTime.getSeconds()
            // return year + "-" +this.addZero(month) + "-" + this.addZero(date) + " " + this.addZero(hour) + ":" + this.addZero(minute) + ":" + this.addZero(second);
            return year + "-" + this.addZero(month) + "-" + this.addZero(date);
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }	
</script>


// WEBPACK FOOTER //
// src/view/labour/labourEnter.vue